import { Box, MenuItem, Pagination, PaginationItem, Select, Typography, useTheme } from '@mui/material';
import React from 'react';

export const PaginationBar = ({
    totalPages,
    currentPage,
    itemsPerPage,
    setCurrentPage,
    setItemsPerPage
}) => {
    const theme = useTheme();
    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleItemsPerPageChange = event => {
        setCurrentPage(1);
        setItemsPerPage(event.target.value);
    };

    return (
        <Box marginTop={'auto'} display="flex" alignItems="center" justifyContent="space-between" p={2}>
            <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(event, value) => {
                    // Prevent going before first page or after last page
                    if (value < 1 || value > totalPages) return;
                    handlePageChange(event, value);
                }}
                siblingCount={0}
                boundaryCount={1}
                renderItem={item => (
                    <PaginationItem
                        {...item}
                        disabled={
                            item.type === 'end-ellipsis' ||
                            item.type === 'start-ellipsis' ||
                            (item.type === 'previous' && currentPage === 1) ||
                            (item.type === 'next' && currentPage === totalPages)
                        }
                    />
                )}
            />
            <Box display="flex" alignItems="center">
                <Typography variant="body2" mr={1} sx={{ color: theme.palette.mode === 'dark' ? '#fff' : '#242333' }}>
                    Éléments par page:
                </Typography>
                <Select value={itemsPerPage} onChange={handleItemsPerPageChange} variant="outlined" size="small">
                    {[12, 24, 36, 48, 60].map(count => (
                        <MenuItem key={count} value={count}>
                            <Typography variant="body2" sx={{ color: theme.palette.mode === 'dark' ? '#fff' : '#0c0d18' }}>
                                {count}
                            </Typography>
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        </Box>
    );
};
